import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { LoginCustomer } from '../../../api/authApi';

// Interfaces
interface AuthLoginState {
    isLoginAuthenticated: boolean;
    loading: boolean;
    otpSent: boolean;
    phone: string | null;
    error: string | null;
    message: string | null;
}


interface LoginPayload {
    phoneNumber: string;
    finCode: string;
}

interface LoginResponse {
    phoneNumber: string;
    status: number;
    message?: string;
}

interface ErrorDetail {
    code: string;
    detail: string;
    attr: string | null;
}

interface StructuredErrorResponse {
    type: 'validation_error' | 'server_error';
    errors: ErrorDetail[];
}

interface GenericErrorResponse {
    error?: string;
}

// Initial state
const initialState: AuthLoginState = {
    isLoginAuthenticated: false,
    loading: false,
    otpSent: false,
    phone: null,
    error: null,
    message:  null
};

// Async thunk
export const login = createAsyncThunk<
LoginResponse,
    LoginPayload,
{ rejectValue: string }
>(
    'login/sendOTP',
        async (payload:LoginPayload, thunkAPI) => {
            try {

                const result = await LoginCustomer(
                    payload.phoneNumber,
                    payload.finCode,


                );


                // Success - status 200
                if (result.status === 200) {
                    sessionStorage.setItem("otpAllowed", "true");
                    const successData = result.data as any;
                    return {
                        phoneNumber: payload.phoneNumber,
                        status: result.status,
                        message: successData.message || 'Uğurlu əməliyyat'
                    };

                }

                // Error handling
                const errorData = result.data;

                // Structured error
                if (errorData && typeof errorData === 'object' && 'type' in errorData && 'errors' in errorData) {
                    const structuredError = errorData as StructuredErrorResponse;
                    const firstError = structuredError.errors[0];
                    return thunkAPI.rejectWithValue(
                        firstError?.detail || 'Xəta baş verdi'
                    );
                }

                // Generic error
                if (errorData && typeof errorData === 'object' && 'error' in errorData) {
                    const genericError = errorData as GenericErrorResponse;
                    return thunkAPI.rejectWithValue(
                        genericError.error || 'Xəta baş verdi'
                    );
                }

                // Network error
                if (result.status === 0) {
                    return thunkAPI.rejectWithValue('Şəbəkə xətası - cavab alınmadı');
                }

                // Default error
                return thunkAPI.rejectWithValue('Gözlənilməz xəta baş verdi');

            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : 'Giriş uğursuzdur';
                return thunkAPI.rejectWithValue(errorMessage);
            }
        }
);

// Slice with reducers

const authLoginSlice = createSlice({
    name: 'login/sendOTP',
    initialState,
    reducers: {

        clearError: (state) => {
            state.error = null;
            state.message = null
        },
        resetLoginState: (state) => {
            state.loading = false;
            state.phone = null;
            state.otpSent = false;
            state.error = null;
            state.message = null
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.message = null;
            })
            .addCase(login.fulfilled, (state, action: PayloadAction<LoginResponse>) => {
                state.loading = false;
                state.phone = action.payload.phoneNumber;
                state.otpSent = true;
                state.error = null;
                state.message = action.payload.message || null;
            })
            .addCase(login.rejected, (state, action) => {
                state.loading = false;
                state.isLoginAuthenticated = false;
                state.error = action.payload || 'Login failed';
                state.message = null;
            });
    }
})

export const { clearError,resetLoginState } = authLoginSlice.actions;
export default authLoginSlice.reducer;